import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { paths } from '../../paths'

export const budgetproductionconsumptionspage: JSX.Element[] = [
  <Route
    component={lazy(async () => {
      const { BudgetProductionConsumptionsPage } = await import(
        /* webpackChunkName: "BudgetProductionVolumesPage" */
        '../../../components/pages/private/BudgetProductionConsumptionsPage'
      )
      return {
        default: BudgetProductionConsumptionsPage,
      }
    })}
    exact
    key={paths.productionConsumptionsImport}
    path={paths.productionConsumptionsImport}
  />,
]
